export type CouponLineItem = {
    itemVariationId?: number | string;
    new?: boolean;
    quantity?: number | string;
};

export function getPseudoQtyForItem(
    couponItems: CouponLineItem[] | undefined,
    itemVariationId: number | string
): number {
    if (!couponItems?.length) {
        return 0;
    }

    return couponItems
        .filter((item) => item.new === true && item.itemVariationId == itemVariationId)
        .reduce((sum, item) => sum + (+item.quantity || 0), 0);
}

export function getMainLineCouponItem(
    couponItems: CouponLineItem[] | undefined,
    itemVariationId: number | string
) {
    return couponItems?.find(
        (item) => item.itemVariationId == itemVariationId && !item.new
    );
}

export function quantityForBackendWithPseudoLine(
    userQuantity: number | string,
    pseudoQty: number
): number {
    return pseudoQty > 0 ? +userQuantity + pseudoQty : +userQuantity;
}
